import React, { useState, useEffect,  } from "react";
import axios from "axios";
import { Collapse } from "antd";
import {
  formsIcon,
  customerHappinessIcon,
  downloadServiceIcon,
  feeEstimatorIcon,
  faqsIcon,
  servicesChargesIcon,
} from "../../assets/header/overlay";
import closeOverlay from "../../assets/close-overlay.svg";
import General from "../../stores/GeneralStore";
import "./sidebar.css";
import { NavLink, useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import constants from "../../utils/constants";

const { Panel } = Collapse;

const SideBar = ({ selectedMenuItem,setSelectedMenuItem,toggleMenu} ) => {

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const navigate = useNavigate();
  const currentLan= localStorage.getItem("settingUplanguage") ?? "en-US";
  const [servicesData, setServicesData] = useState(null);
  const pdfNavLink = currentLan=='ar'?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ENPages2025.pdf`:currentLan=="hi"?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_HIPages2025.pdf`:`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ENPages2025.pdf`;

  useEffect(() => {
    const getServices = async () => {
      try {
        const response = await axios.get(
          `${constants.URL.BASE_URL}ASPCL/web/GetServiceGuide`,
          {
            params: {
              lang: currentLan?currentLan:'en-US',
            },
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // Check if the response is successful
        if (response.status === 200) {
          const data = response.data; // Access response data
          // Process the retrieved data here
          setServicesData(data);
        }
      } catch (error) {
        // Handle any network or other errors
      }
    };

    getServices();
  }, []);
 
  const pdfLink = currentLan=='ar'?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ARPages2025.pdf`:currentLan=="hi"?`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_HIPages2025.pdf`:`${constants?.URL.CORPORATE_WEBSITE}serviceGuides/ASPCL_Service-Doc_ENPages2025.pdf`;

  function handleDownloadClick(pdfUrl) {
    var xhr = new XMLHttpRequest();
    xhr.open(
      "GET",
      pdfUrl,
      true
    );
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        var blob = xhr.response;
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Service Guide.pdf";
        link.click();
      }
    };
    xhr.send();
  }
  const currentURL = window.location.href;
  const lastItem = currentURL.split("#").pop();
  const renderMenuContent = () => {
    switch (selectedMenuItem) {
      case "about":
        return (
          <div className="about">
            <NavLink

              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',

                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/aboutajmansewerage`)}
      
            >
             {General?.codeLabels["cm_abt_cmpny"]?.label !== undefined ? General?.codeLabels["cm_abt_cmpny"]?.label : "ABOUT THE COMPANY"} 
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/ourteam`)}
            >
             {General?.codeLabels["cm_our_team"]?.label !== undefined ? General?.codeLabels["cm_our_team"]?.label : "Our Team"}  
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/collectionnetwork`)}
            >
              {General?.codeLabels["cm_clc_network"]?.label !== undefined ? General?.codeLabels["cm_clc_network"]?.label : "Collection Network"} 
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/treatmentplant`)}
            >
             {General?.codeLabels["cm_trt_plnt"]?.label !== undefined ? General?.codeLabels["cm_trt_plnt"]?.label : "Treatment Plant"}   
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/communitycarefoundation`)}
            >
             {General?.codeLabels["cm_cminty_foundation"]?.label !== undefined ? General?.codeLabels["cm_cminty_foundation"]?.label : "Community Care Foundation"}
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/aboutus/milestones`)}
            >
               {General?.codeLabels["cm_milestones"]?.label !== undefined ? General?.codeLabels["cm_milestones"]?.label : "Milestones"}
            </NavLink>
          </div>
        );

      case "services":
        return (
          <div className="services">
            <div className="parent">
              <ul>
                <div className="tenants" style={{
                  color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                }}> 
                {General?.codeLabels["cm_tenants"]?.label !== undefined ? General?.codeLabels["cm_tenants"]?.label : "FOR TENANTS"} 
                 </div>
                {servicesData?.data?.map((service) => {
                  const groupTypes = JSON.parse(service?.groupType);
                  if (groupTypes?.includes("tenant")) {
                    const handleNavigation = () => {
                      window.open(
                        `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`,{state:{serviceGuideTitle:service?.serviceGuideTitle}},
                      );
                    };

                    return (
                      <li
                        style={{
                          color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                        }}
                        key={service?.id}
                        onClick={handleNavigation}
                        className={
                          lastItem == service.serviceGuidePageLink
                            ? "active"
                            : ""
                        }
                      >
                        {service?.serviceGuideTitle}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
              <ul>
                <div className="owners" style={{
                  color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                }}>
                {General?.codeLabels["cm_owners"]?.label !== undefined ? General?.codeLabels["cm_owners"]?.label : "FOR OWNERS"} 
                 </div>
                {servicesData?.data?.map((service) => {
                  const groupTypes = JSON.parse(service.groupType);
                  if (groupTypes.includes("owner")) {
                    const handleNavigation = () => {
                      window.open(
                        `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`
                      );
                    };
                    return (
                      <li style={{
                        color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                      }} key={service.id} onClick={handleNavigation} className={
                        lastItem == service.serviceGuidePageLink
                          ? "active"
                          : ""
                      }>
                        {service.serviceGuideTitle}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
              <ul className="consultant">
                <div style={{
                  color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                }}>
                     {General?.codeLabels["cm_consultants"]?.label !== undefined ? General?.codeLabels["cm_consultants"]?.label : "FOR CONSULTANTS"} 
                     </div>
                {servicesData?.data?.map((service) => {
                  const groupTypes = JSON.parse(service.groupType);
                  if (groupTypes.includes("consultant")) {
                    const handleNavigation = () => {
                      window.open(
                        `${constants?.URL.CORPORATE_WEBSITE}home/ourservices/servicesguide#${service.serviceGuidePageLink}`
                      );
                    };
                    return (
                      <li style={{
                        color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                      }} key={service.id} onClick={handleNavigation} className={
                        lastItem == service.serviceGuidePageLink
                          ? "active"
                          : ""
                      }>
                        {service.serviceGuideTitle}
                      </li>
                    );
                  }
                  return null;
                })}
              </ul>
            </div>
            <div className="useful-links">
              <div className="heading" style={{
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
              }}>
                {General?.codeLabels["cm_useful_links"]?.label !== undefined ? General?.codeLabels["cm_useful_links"]?.label : "USEFUL LINKS & GUIDES"} 
                </div>
              <div className="btn-links">
                <div
                  style={{
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:''
                  }}
                  className="btn"
                  onClick={() => handleDownloadClick(pdfNavLink)}
                >
                  <img src={downloadServiceIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}>{General?.codeLabels["cm_download_srvice"]?.label !== undefined ? General?.codeLabels["cm_download_srvice"]?.label : "Download Service Guide"} </span>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    window.open(`${constants?.URL.CORPORATE_WEBSITE}home/servicecharges`);
                  }}
                  style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                  }}
                >
                  <img src={servicesChargesIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}>
                   {General?.codeLabels["cm_charges_srvice"]?.label !== undefined ? General?.codeLabels["cm_charges_srvice"]?.label : "Services Charges/ Tariff"}
                  </span>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    window.open(`${constants?.URL.CORPORATE_WEBSITE}home/ourservices/faq`);
                  }}
                  style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                  }}
                >
                  <img src={faqsIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}> 
                  {General?.codeLabels["cm_faqs"]?.label !== undefined ? General?.codeLabels["cm_faqs"]?.label : "FAQs"}
                  </span>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    window.open(`${constants?.URL.CORPORATE_WEBSITE}home/ourservices/customerhappinesscenters`);
                  }}
                  style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                  }}
                >
                  <img src={customerHappinessIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}>
                    {General?.codeLabels["cm_customer_happiness"]?.label !== undefined ? General?.codeLabels["cm_customer_happiness"]?.label : "Customer Happiness Centers"}
                     </span>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    window.open(`${constants?.URL.CORPORATE_WEBSITE}home/ourservices/forms`);
                  }}
                  style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                  }}
                >
                  <img src={formsIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}>
                     {General?.codeLabels["cm_form_tenants"]?.label !== undefined ? General?.codeLabels["cm_form_tenants"]?.label : "Forms (For Tenants)"}
                     </span>
                </div>
                <div
                  className="btn"
                  onClick={() => {
                    window.open(`${constants?.URL.CORPORATE_WEBSITE}connectionfeeestimator`);
                  }}
                  style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                    background: contrast?.contrastColor?contrast?.contrastColor:'',
                  }}
                >
                  <img src={feeEstimatorIcon} />
                  <span style={{
                    color: contrast?.contrastBackground?contrast?.contrastBackground:ColorAss?ColorAss:'',
                  }}> 
                  {General?.codeLabels["cm_bill_estimator"]?.label !== undefined ? General?.codeLabels["cm_bill_estimator"]?.label : "Connection Fee Estimator"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );

      case "sustainability":
        return (
          <div className="about">
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
                
              }}
              // className="active"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/sustainability/sustainability-efforts`)}
            >
              {General?.codeLabels["cm_our_sustainability"]?.label !== undefined ? General?.codeLabels["cm_our_sustainability"]?.label : "Our Sustainability Efforts"}
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/sustainability/howcanyouhelp?`)}
            >
             {General?.codeLabels["cm_selectservicelabel"]?.label !== undefined ? General?.codeLabels["cm_selectservicelabel"]?.label : "How can we help you?"}
            </NavLink>
          </div>
        );
      case "media":
        return (
          <div className="about">
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/mediacenter/news&events`)}
            >
            {General?.codeLabels["cm_news_events"]?.label !== undefined ? General?.codeLabels["cm_news_events"]?.label : "News & Events"}
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/mediacenter/mediagallery`)}
            >
             {General?.codeLabels["cm_media_gallery"]?.label !== undefined ? General?.codeLabels["cm_media_gallery"]?.label : "Media Gallery"}
            </NavLink>
          </div>
        );
      case "contact":
        return (
          <div className="about">
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CUSTOMER_PORTAL_NEW}complaint`)}
            >
             {General?.codeLabels["cm_submit_feedback"]?.label !== undefined ? General?.codeLabels["cm_submit_feedback"]?.label : "Submit Feedback"}
            </NavLink>
            <NavLink
              style={{
                textDecoration: "none",
                color: contrast?.contrastColor?contrast?.contrastColor:ColorAss?ColorAss:'#101e8e',
                lineHeight: "48px",
              }}
              className="link"
              onClick={()=>window.open(`${constants?.URL.CORPORATE_WEBSITE}home/reachus/contactinfo`)}
            >
            {General?.codeLabels["cm_contact_info"]?.label !== undefined ? General?.codeLabels["cm_contact_info"]?.label : "Contact Info"}
            </NavLink>
          </div>
        );
      default:
        return null;
    }
  };

  return(
    <div
    className="menu-overlay"
    style={{
     left: currentLan=="ar"?'0px':'',right: currentLan!="ar"?'0px':'',
      backgroundColor: contrast?.contrastBackground?contrast?.contrastBackground:"",
      color: contrast?.contrastColor?contrast?.contrastColor:'#101e8e'
    }}
  >
    <div className="menu-content" style={{
      backgroundColor: contrast?.contrastBackground?contrast?.contrastBackground:"",
    }}>
      <div className="close-icon" onClick={toggleMenu}>
        <img src={closeOverlay} alt="Close Menu" />
      </div>

      <div className="content">
        <div className="menu-content-data" >{renderMenuContent()}</div>

        <div
          style={{
            borderImageSource:
              "linear-gradient(180deg, #C2C2C2 0%, #FFFFFF 100%)",
            borderImageSlice: 1,
            borderStyle: "solid",
            borderWidth: "0px",
            borderInlineStartWidth: "2px",
            height: "578px",
            paddingInline: "20px",
          }}
        >
          <ul className="menu-li">
            <li
              onClick={() => {
                localStorage.setItem("menuItem", "about");
                setSelectedMenuItem("about");
              }}
              className={selectedMenuItem === "about" ? "active" : ""}
              style={{
                color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
            >
              {General?.codeLabels["cm_abt_aspcl"]?.label !== undefined ? General?.codeLabels["cm_abt_aspcl"]?.label : "About aspcl"}
            </li>
            <li
              style={{
                color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
              onClick={() => {
                setSelectedMenuItem("services");
                localStorage.setItem("menuItem", "services");
              }}
              className={selectedMenuItem === "services" ? "active" : ""}
            >
             {General?.codeLabels["cm_services"]?.label !== undefined ? General?.codeLabels["cm_services"]?.label : "Our Services"}
            </li>
            <li
              style={{
                color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
              onClick={() => {
                localStorage.setItem("menuItem", "sustainability");
                setSelectedMenuItem("sustainability");
              }}
              className={
                selectedMenuItem === "sustainability" ? "active" : ""
              }
            >
              {General?.codeLabels["cm_sustainability"]?.label !== undefined ? General?.codeLabels["cm_sustainability"]?.label : "Sustainability"}
            </li>
            <li
              style={{
                color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
              onClick={() => {
                localStorage.setItem("menuItem", "media");
                setSelectedMenuItem("media");
              }}
              className={selectedMenuItem === "media" ? "active" : ""}
            >
          {General?.codeLabels["cm_media_center"]?.label !== undefined ? General?.codeLabels["cm_media_center"]?.label : "Media Centre"} 
            </li>
            <li
              style={{
                color: contrast?.contrastColor?contrast?.contrastColor:''
              }}
              onClick={() => {
                localStorage.setItem("menuItem", "contact");
                setSelectedMenuItem("contact");
              }}
              className={selectedMenuItem === "contact" ? "active" : ""}
            >
        {General?.codeLabels["cm_reach_us"]?.label !== undefined ? General?.codeLabels["cm_reach_us"]?.label : "Reach Us"} 
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  );
};
export default observer(SideBar);
